import { render, staticRenderFns } from "./FlatButton.vue?vue&type=template&id=38205b50&"
import script from "./FlatButton.vue?vue&type=script&lang=js&"
export * from "./FlatButton.vue?vue&type=script&lang=js&"
import style0 from "./FlatButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports